var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 49,
    viewBox: "0 0 117 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3739 43.3571L29.8435 7.52857C28.3174 2.04286 25.4348 0.5 21.3652 0.5H0C1.69565 1.18571 2.71304 5.47143 2.71304 5.47143L13.0565 41.4714C14.2435 45.9286 17.9739 48.3286 22.213 48.3286H44.7652C43.0696 48.1571 41.3739 43.3571 41.3739 43.3571Z",
    fill: "#DA1710"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6257 43.3571L87.1561 7.52857C88.6822 2.04286 91.5648 0.5 95.6344 0.5H117C115.304 1.18571 114.287 5.47143 114.287 5.47143L103.943 41.4714C102.756 45.9286 99.0257 48.3286 94.7865 48.3286H72.2344C73.93 48.1571 75.6257 43.3571 75.6257 43.3571Z",
    fill: "#DA1710"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2175 0.5H45.7827V48.5H71.2175V0.5Z",
    fill: "#DA1710"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWp);
export default __webpack_public_path__ + "static/media/wp.9462d1c4.svg";
export { ForwardRef as ReactComponent };